/**
 * Created by Sebastian on 23.11.2015.
 */
import importHtmlTemplate from "./import.html";
import excelHtml from "./states/excel/excel.html";

/**s
 * The abstract import state. Everything related to
 * import is under this state, e.g. excel & package
 * @param {object} $stateProvider - state provider
 */
export default function ImportStateConfiguration($stateProvider) {
    "ngInject";

    $stateProvider.state("sablono.project.import", {
        abstract: true,
        templateUrl: importHtmlTemplate,
        controller: "ImportCtrl",
        controllerAs: "rootImport",
        url: "/import",
    });
    $stateProvider.state("sablono.project.import.excel", {
        url: "/excel",
        gaPageTrack: "/import/excel", // google analytics extension
        templateUrl: excelHtml,
        controller: "ExcelCtrl",
        controllerAs: "importExcel",
        data: {
            title: "SECTION_EXCEL_IMPORT_TITLE",
            icon: "sb-icon-excel_outline",
            category: "PLAN",
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            "ngInject";
            intercomService.track(TRACKED_EVENTS.ENTERED_EXCEL_IMPORT_PAGE);
        },
        resolve: {},
    });
    $stateProvider.state("sablono.project.import.packages", {
        url: "/packages",
        gaPageTrack: "/import/packages", // google analytics extension
        template: "",
        controller: "ImportPackagesCtrl",
        controllerAs: "importPackages",
        data: {
            title: "SECTION_EXCEL_IMPORT_DATES_TITLE",
            icon: "sb-icon-excel_outline",
            category: "PLAN",
        },
        onEnter: function (intercomService, TRACKED_EVENTS) {
            "ngInject";
            intercomService.track(TRACKED_EVENTS.ENTERED_EXCEL_IMPORT_PAGE);
        },
    });
}
